export class BrokerContextModel {
  brokerCode: string;
  brokerHouse: string;
  callCenterNumber: string;
  mandateReference: string; // broker context requires mandateReference
  mandateRef: string; // broker reference service has mandateReference as mandateRef
}
